import { BANKRATE, NERDWALLET, WSJ } from 'components/featured-lender-banner/const'
import { PSL, SLR } from 'common/const/marketplace'
import { INSCHOOL, REFI } from 'common/const/verticalNames'

import wsjStyles from './themes/wsj.module.scss'
import bankrateStyles from './themes/bankrate.module.scss'
import nerdwalletStyles from './themes/nerdwallet.module.scss'

export const STYLES = {
  [WSJ]: wsjStyles,
  [BANKRATE]: bankrateStyles,
  [NERDWALLET]: nerdwalletStyles,
}

export const LENDERS_BY_VERTICAL = {
  [SLR]: {
    lenders: ['sofi', 'earnest'],
    lendersNames: ['SoFi', 'Earnest'],
    apiVerticalName: REFI,
  },
  [PSL]: {
    lenders: ['cas', 'sallie-mae'],
    lendersNames: ['College Ave', 'Sallie Mae'],
    apiVerticalName: INSCHOOL,
  },
}
